import axios from '@config/axios-config';
import { IApiResponse } from '@datatype/common/api-type';
import { ICreatePushTokenRequest } from '@datatype/message/api-type';
import { IPushTokenData } from '@datatype/message/api-type';

// ###################################
// push token
// ###################################
export const createPushToken = async (request: ICreatePushTokenRequest): Promise<IApiResponse<IPushTokenData>> => {
  const response = await axios
    .post<IApiResponse<IPushTokenData>>(`/api/v1/message/push-token`, {
      platform: request.platform,
      service: request.service,
      deviceId: request.deviceId,
      token: request.token,
    })
    .then((res) => res.data);
  return response;
};
